import { Heading } from "@trueskin-web/components"

const SignupTop = ({ heading, subline, image: Image }) => (
  <>
    <Heading
      as="h1"
      sx={{
        mb: 2,
        textAlign: "center",
        fontSize: 6,
        lineHeight: 1.25,
        fontFamily: "display",
      }}
    >
      {heading}
    </Heading>
    <div
      sx={{
        textAlign: "center",
        color: "neutralsDarkGrey",
      }}
    >
      {subline}
    </div>
    <Image alt="Signup Page" sx={{ mt: 4 }} />
  </>
)

export default SignupTop
